import API_BASE_URL from "../../../../../Constants";

export const deleteBuilding = async (buildingId) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/buildings/${buildingId}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );
  const message = await response.text();
  if (!response.ok) throw new Error(message);

  return message;
};
